import React from 'react';
import { shape, func, string, arrayOf, bool } from 'prop-types';

import Forms from '.';

const CheckboxGroup = ({
    disabled,
    flatBottom,
    isVertical,
    label,
    labelIsBold,
    labelIsHidden,
    checkedLabelIsBold,
    name,
    onChange,
    options,
    readonly,
    value
}) => {
    if (!options || !options.length) {
        return null;
    }

    return (
        <Forms.FormGroup
            flatBottom={flatBottom}
            htmlFor={options[0].id.toString()}
            label={label}
            labelIsBold={labelIsBold}
            labelIsHidden={labelIsHidden}
        >
            {options.map(item => {
                return (
                    <React.Fragment key={item.id}>
                        <div
                            className={`checkbox-wrapper ${
                                isVertical ? 'is-vertical' : ''
                            }`}
                        >
                            <input
                                checked={
                                    value && value === item.value
                                        ? true
                                        : item.checked
                                }
                                disabled={readonly || disabled || item.disabled}
                                id={item.id.toString()}
                                name={name}
                                onChange={onChange}
                                type="checkbox"
                                value={item.value}
                            />
                            <label
                                htmlFor={item.id.toString()}
                                className={`
                                ${
                                    disabled || item.disabled
                                        ? 'is-disabled'
                                        : ''
                                }
                                ${
                                    checkedLabelIsBold
                                        ? 'label--checked-bold'
                                        : ''
                                }
                            `}
                                dangerouslySetInnerHTML={{
                                    __html: item.label.toString()
                                }}
                            />
                        </div>
                        {!!item.subOptions && !!item.subOptions.length && (
                            <div className="checkbox-subOptions-container">
                                {item.subOptions.map(subOption => (
                                    <div
                                        key={subOption.id}
                                        className="checkbox-wrapper is-vertical"
                                    >
                                        <input
                                            checked={
                                                value &&
                                                value === subOption.value
                                                    ? true
                                                    : subOption.checked
                                            }
                                            disabled={
                                                readonly ||
                                                disabled ||
                                                subOption.disabled
                                            }
                                            id={subOption.id.toString()}
                                            name={name}
                                            onChange={onChange}
                                            type="checkbox"
                                            value={subOption.value}
                                        />
                                        <label
                                            htmlFor={subOption.id.toString()}
                                            className={`
                                   ${
                                       disabled || subOption.disabled
                                           ? 'is-disabled'
                                           : ''
                                   }
                                   ${
                                       checkedLabelIsBold
                                           ? 'label--checked-bold'
                                           : ''
                                   }
                               `}
                                            dangerouslySetInnerHTML={{
                                                __html: subOption.label.toString()
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
        </Forms.FormGroup>
    );
};

CheckboxGroup.propTypes = {
    disabled: bool,
    flatBottom: bool,
    isVertical: bool,
    isHorizontal: bool,
    label: string.isRequired,
    labelIsBold: bool,
    labelIsHidden: bool,
    checkedLabelIsBold: bool,
    name: string.isRequired,
    onChange: func.isRequired,
    options: arrayOf(
        shape({
            id: string,
            value: string,
            label: string,
            checked: bool,
            disabled: bool
        })
    ).isRequired,
    readonly: bool,
    value: string
};

export default CheckboxGroup;
